import React, { FC } from "react"

import { DeviceDocument } from "../../../../contexts/devices-context"
import LightModuleSettings from "./LightModuleSettings"
import useModuleAttributes from "../../hooks/useModuleAttributes"

type DeviceLightsSettingsCardProps = {
    device: DeviceDocument
}

const _DeviceLightsModuleSettings: FC<DeviceLightsSettingsCardProps> = ({ device }) => {
    const attrs = useModuleAttributes<"brightness">(device, "lights")

    return (
        <LightModuleSettings attrs={attrs} organisation={device.organisation} group={device.group} device={device} />
    )
}

export default _DeviceLightsModuleSettings
